import { calculator } from "./calculator";

const getHeaderPartFloat = function(parts, searchTerm)
{
    for(var i=0; i < parts.length; i++)
    {
        const part = parts[i];
        const index = part.indexOf(searchTerm);
        if(index >= 0)
        {
            const vx = part.substring(index + searchTerm.length, part.length);
            const result = parseFloat(vx);
            return result;
        }
    }
    return null;
};

const stringContains = function(text,searchTerm)
{
    const index = text.indexOf(searchTerm);
    if(index >= 0)
        return true;
    
    return false;
};

const readSensorsMessage = function(msg)
{
    const parts = msg.split(";");
    const result = 
    {
        tModule : this.getHeaderPartFloat(parts,"Tm="),
        light : this.getHeaderPartFloat(parts,"E="),
        tHeatsink: this.getHeaderPartFloat(parts,"Tt="),  
        
        current: this.getHeaderPartFloat(parts,"I="), 
        rawVoltage: this.getHeaderPartFloat(parts,"V="), 
        voltageMultiplier: this.getHeaderPartFloat(parts,"Vx="),     
    };

    if(result.rawVoltage != null && result.voltageMultiplier != null)
    {
        result.voltage = calculator.parseIntWithOverflow(result.rawVoltage) * result.voltageMultiplier / 1000;                
    }           
    
    if(result.current != null)
    {
        result.current = calculator.parseIntWithOverflow(result.current) / 1000;
    }
    return result;
};

const readState = function(name,msg){
    const parts = msg.split(";");
    const result = 
    {
        isOn : this.getHeaderPartFloat(parts, name),
    };
    return result;
};  

export const parser = {
    getHeaderPartFloat,
    stringContains,
    readSensorsMessage,
    readState
}